import createApi from './api';

const chatApi = createApi({
  baseUrl: "chat",
  headers: {
    "Content-Type": "application/json",
  },
});

export default class ChatService {
  async getHistory() {
    return await chatApi.post('history');
  }

  async askGPT({ query }) {
    return await chatApi.post('gpt', { query });
  }
}
